module.exports = __webpack_public_path__ + "img/9788956050621.6207a43b.jpg";